// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container {
  display: flex;
  min-width: 0;
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
}

.auth-page {
  flex-direction: column;
}

.auth-page > .content {
  box-sizing: border-box;
  padding: 0;
}

.content {
  flex: 1 1;
  min-width: 0;
  width: 100%;
}

.full-width {
  flex: 1 1;
}

.app-shell {
  display: block;
}

.app-shell > .content {
  box-sizing: border-box;
  max-width: 100%;
  padding: calc(var(--app-header-height) + var(--safe-area-top) + clamp(1rem, 2.5vw, 2rem)) clamp(1rem, 2.5vw, 2rem) clamp(1rem, 2.5vw, 2rem);
}

@media (min-width: 769px) and (max-width: 1024px) {
  .app-shell > .content {
    padding: clamp(1rem, 2vw, 1.5rem);
  }
}

@media (max-width: 768px) {
  .app-shell {
    display: block;
  }

  .app-shell > .content {
    width: 100%;
    padding: calc(var(--app-header-height) + var(--safe-area-top) + clamp(0.75rem, 4vw, 1.25rem)) clamp(0.75rem, 4vw, 1.25rem) clamp(0.75rem, 4vw, 1.25rem);
    padding-bottom: calc(
      var(--mobile-navigation-height) + clamp(0.75rem, 4vw, 1.25rem) +
        var(--safe-area-bottom)
    );
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,2IAA2I;AAC7I;;AAEA;EACE;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,uJAAuJ;IACvJ;;;KAGC;EACH;AACF","sourcesContent":[".app-container {\r\n  display: flex;\r\n  min-width: 0;\r\n  min-height: 100vh;\r\n  min-height: 100dvh;\r\n  width: 100%;\r\n}\r\n\r\n.auth-page {\r\n  flex-direction: column;\r\n}\r\n\r\n.auth-page > .content {\r\n  box-sizing: border-box;\r\n  padding: 0;\r\n}\r\n\r\n.content {\r\n  flex: 1;\r\n  min-width: 0;\r\n  width: 100%;\r\n}\r\n\r\n.full-width {\r\n  flex: 1;\r\n}\r\n\r\n.app-shell {\r\n  display: block;\r\n}\r\n\r\n.app-shell > .content {\r\n  box-sizing: border-box;\r\n  max-width: 100%;\r\n  padding: calc(var(--app-header-height) + var(--safe-area-top) + clamp(1rem, 2.5vw, 2rem)) clamp(1rem, 2.5vw, 2rem) clamp(1rem, 2.5vw, 2rem);\r\n}\r\n\r\n@media (min-width: 769px) and (max-width: 1024px) {\r\n  .app-shell > .content {\r\n    padding: clamp(1rem, 2vw, 1.5rem);\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .app-shell {\r\n    display: block;\r\n  }\r\n\r\n  .app-shell > .content {\r\n    width: 100%;\r\n    padding: calc(var(--app-header-height) + var(--safe-area-top) + clamp(0.75rem, 4vw, 1.25rem)) clamp(0.75rem, 4vw, 1.25rem) clamp(0.75rem, 4vw, 1.25rem);\r\n    padding-bottom: calc(\r\n      var(--mobile-navigation-height) + clamp(0.75rem, 4vw, 1.25rem) +\r\n        var(--safe-area-bottom)\r\n    );\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
